<strong class="strong strong--{{ weight }}">
  <ng-content></ng-content>
</strong>
